import React, { useCallback, useEffect, useState } from 'react'
import { Image, Text, StyleSheet } from 'react-native'
import { useLocalSearchParams, useRouter } from 'expo-router'

import { CardList } from '../../components/CardList/CardList'
import { PaddedLayout } from '../../components/layouts/PaddedLayout'
import { SecondaryButton } from '../../components/SecondaryButton/SecondaryButton'
import { gamesData } from './data'
import { Game, isSurveyGame } from './interfaces/mini-games.interface'
import { fontFamily } from '../../theme/fontFamily'

export const IntroScreen = () => {
  const router = useRouter()
  const { gameName } = useLocalSearchParams<{ gameName: string }>()

  const [gameData, setGameData] = useState<Game>()

  useEffect(() => {
    const currentGame = gamesData.find((game: Game) => game.name === gameName)

    setGameData(currentGame)
  }, [gameName])

  const onPress = useCallback(() => {
    if (!gameData) {
      return
    }
    if (isSurveyGame(gameData)) {
      router.navigate(`/minigames/survey?gameName${gameName}`)
      return
    }
    router.navigate(`/minigames/versus?gameName${gameName}`)
  }, [router, gameData, gameName])

  if (!gameData) return null

  return (
    <PaddedLayout>
      {gameData && <Image style={styles.image} source={gameData.img} />}

      {gameData && <CardList cards={gameData.cards} />}

      {gameData && <Text style={styles.description}>{gameData.gameDescription}</Text>}

      <SecondaryButton
        textProps={{ tx: 'miniGamesScreen.introScreen.startGameButton', style: styles.buttonText }}
        onPress={onPress}
      />
    </PaddedLayout>
  )
}

const styles = StyleSheet.create({
  image: {
    marginBottom: 30,
    alignSelf: 'center'
  },
  description: {
    fontFamily: fontFamily.sfProDisplayRegular,
    fontSize: 14,
    lineHeight: 17,
    textAlign: 'center',
    alignSelf: 'center',
    color: '#FFFFFF',
    marginVertical: 25,
    maxWidth: '70%'
  },
  buttonText: {
    fontFamily: fontFamily.sfProDisplayBlackItalic,
    fontSize: 18,
    lineHeight: 21
  }
})
